import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { productTransactionHistoryList } from '../../services/Api';

export const fetchProductTransactionHistory = createAsyncThunk(
    'productTransactionHistory/fetchProductTransactionHistory',
    async (_, { getState }) => {
        try {
            const { filters } = getState().productTransactionHistory;

            // Prepare parameters conditionally
            const params = {
                sort: 'id',
                sort_order: filters.sorting || 'desc',
                page: filters.page,
                paginate_per_page: filters.paginate_per_page,
                ...(filters.search && { product_name: filters.search }),
                ...(filters.from && { from: filters.from }),
                ...(filters.to && { to: filters.to }),
                ...(filters.transaction_status && { transaction_status: filters.transaction_status })
            };


            const response = await productTransactionHistoryList(params);
            return response;
        } catch (error) {
            throw error;
        }
    }
);

const initialState = {
    transactions: [],
    loading: false,
    error: null,
    pagination: {
        currentPage: 1,
        totalPage: 1,
        showing: 10,
        total: 0
    },
    filters: {
        from: '',
        to: '',
        search: '',
        transaction_status: '',
        sorting: 'desc',
        page: "1",
        paginate_per_page: "10"
    }
};

const productTransactionHistorySlice = createSlice({
    name: 'productTransactionHistory',
    initialState,
    reducers: {
        setFilters: (state, action) => {
            state.filters = { ...state.filters, ...action.payload };
        },
        resetFilters: (state) => {
            state.filters = initialState.filters;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchProductTransactionHistory.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchProductTransactionHistory.fulfilled, (state, action) => {
                state.loading = false;
                state.transactions = action.payload.data || [];
                if (action.payload.meta) {
                    state.pagination = {
                        currentPage: action.payload.meta.current_page || 1,
                        totalPage: action.payload.meta.last_page || 1,
                        showing: action.payload.meta.per_page || 10,
                        total: action.payload.meta.total || 0
                    };
                }
            })
            .addCase(fetchProductTransactionHistory.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
                state.transactions = [];
            });
    }
});

export const { setFilters, resetFilters } = productTransactionHistorySlice.actions;
export default productTransactionHistorySlice.reducer;